<template>
  <v-data-table :headers="headers" :items="items" hide-actions class="c-insurance-plan simple-table">
    <template slot="headers" slot-scope>
      <tr>
        <th class="text-xs-left">投保员工人数</th>
        <th class="thead-th">
          1-3类职业
          <strong v-if="employees.length > 0">{{ oc3Count }}</strong>
          <v-text-field v-else v-model.number="categoryCounter.oc3Count" class="thead-input"></v-text-field>人
        </th>
        <th class="thead-th">
          4类职业
          <strong v-if="employees.length > 0">{{ oc4Count }}</strong>
          <v-text-field v-else v-model.number="categoryCounter.oc4Count" class="thead-input"></v-text-field>人
        </th>
        <th class="thead-th">
          5类职业
          <strong v-if="employees.length > 0">{{ oc5Count }}</strong>
          <v-text-field v-else v-model.number="categoryCounter.oc5Count" class="thead-input"></v-text-field>人
        </th>
      </tr>
    </template>
    <template slot="items" slot-scope="props">
      <tr>
        <td>{{ props.item.name }}</td>
        <td>
          <v-layout justify-center align-center>
            <v-select
              v-model="props.item.selected.oc3"
              :items="selectesItems[props.index].oc3"
              :disabled="props.index === 3 ? disabledZyylx : false"
              class="v-select"
              solo
              hide-details
              background-color="#dd122a"
              dark
              @change="vselectOnChange(props.index,3)"
            ></v-select>
          </v-layout>
        </td>
        <td>
          <v-layout justify-center align-center>
            <v-select
              v-model="props.item.selected.oc4"
              :items="selectesItems[props.index].oc4"
              :disabled="props.index === 3 ? disabledZyylx : false"
              class="v-select"
              solo
              hide-details
              background-color="#dd122a"
              dark
              @change="vselectOnChange(props.index,4)"
            ></v-select>
          </v-layout>
        </td>
        <td>
          <v-select
            v-model="props.item.selected.oc5"
            :items="selectesItems[props.index].oc5"
            :disabled="props.index === 3 ? disabledZyylx : false"
            class="v-select"
            solo
            hide-details
            background-color="#dd122a"
            dark
            @change="vselectOnChange(props.index,5)"
          ></v-select>
        </td>
      </tr>
    </template>
    <template slot="footer">
      <td>
        <strong>保费</strong>
      </td>
      <td class="text-xs-center">
        <strong class="primary-text">￥ {{ oc3Price }}</strong>
        <span v-show="oc3Count > 0" class="caption">(每人￥ {{ (oc3Price/oc3Count).toFixed(2) }})</span>
      </td>
      <td class="text-xs-center">
        <strong class="primary-text">￥ {{ prices.oc4 }}</strong>
        <span v-show="oc4Count > 0" class="caption">(每人￥ {{ (prices.oc4/oc4Count).toFixed(2) }})</span>
      </td>
      <td class="text-xs-center">
        <strong class="primary-text">￥ {{ prices.oc5 }}</strong>
        <span v-show="oc5Count > 0" class="caption">(每人￥ {{ (prices.oc5/oc5Count).toFixed(2) }})</span>
      </td>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    code: {
      type: String,
      default: ""
    },
    // planId: Number,
    employees: {
      type: Array,
      default() {
        return [];
      }
    },
    effectDuration: {
      type: Number,
      default: 12
    }
  },
  data() {
    return {
      // 产品方案只有一个方案D了。原来是选择的，从 props 接受，现在只有一个了直接定义在这里
      planId:4,
      headers: [
        {
          text: "投保员工人数",
          value: "name",
          sortable: false
        },
        {
          text: "1-3类职业0人",
          value: "insuranceAmountList",
          sortable: false,
          width: "200"
        },
        {
          text: "4类职业0人",
          sortable: false,
          width: "200"
        },
        {
          text: "5类职业0人",
          sortable: false,
          width: "200"
        }
      ],
      items: [
        {
          name: "人身意外伤害保险",
          insuranceAmountList: [
            { text: "5万", value: 50000 },
            { text: "10万", value: 100000 },
            { text: "20万", value: 200000 },
            { text: "30万", value: 300000 },
            { text: "40万", value: 400000 },
            { text: "50万", value: 500000 },
            { text: "60万", value: 600000 },
            { text: "70万", value: 700000 },
            { text: "80万", value: 800000 }
          ],
          limits: [
            {
              minOccupationalCategory: 1,
              maxOccupationalCategory: 3,
              maxInsuranceAmount: 800000
            },
            {
              minOccupationalCategory: 4,
              maxOccupationalCategory: 4,
              maxInsuranceAmount: 600000
            },
            {
              minOccupationalCategory: 5,
              maxOccupationalCategory: 5,
              maxInsuranceAmount: 500000
            }
          ],
          selected: {
            oc3: 100000,
            oc4: 100000,
            oc5: 100000
          }
        },
        {
          name: "意外伤害医疗保险",
          insuranceAmountList: [
            { text: "不投保", value: 0 },
            { text: "5000元", value: 5000 },
            { text: "1万", value: 10000 },
            { text: "2万", value: 20000 },
            { text: "3万", value: 30000 },
            { text: "4万", value: 40000 },
            { text: "5万", value: 50000 },
            { text: "6万", value: 60000 },
            { text: "7万", value: 70000 },
            { text: "8万", value: 80000 }
          ],
          limits: [
            {
              minOccupationalCategory: 1,
              maxOccupationalCategory: 3,
              maxInsuranceAmount: [80000, "${primary} * 0.2"]
            },
            {
              minOccupationalCategory: 4,
              maxOccupationalCategory: 5,
              maxInsuranceAmount: [60000, "${primary} * 0.1"]
            }
          ],
          selected: {
            oc3: 10000,
            oc4: 10000,
            oc5: 10000
          }
        },
        {
          name: "意外伤害住院津贴",
          insuranceAmountList: [
            { text: "不投保", value: 0 },
            { text: "30元/天", value: 30 },
            { text: "50元/天", value: 50 },
            { text: "100元/天", value: 100 },
            { text: "150元/天", value: 150 },
            { text: "200元/天", value: 200 }
          ],
          limits: [
            {
              minOccupationalCategory: 1,
              maxOccupationalCategory: 5,
              maxInsuranceAmount: [200, "${primary} * 0.001"]
            }
          ],
          selected: {
            oc3: 50,
            oc4: 50,
            oc5: 50
          }
        },
      ],
      // select items 数据
      selectesItems: [
        {
          oc3: [],
          oc4: [],
          oc5: []
        },
        {
          oc3: [],
          oc4: [],
          oc5: []
        },
        {
          oc3: [],
          oc4: [],
          oc5: []
        }
      ],
      prices: {
        oc1: 0,
        oc2: 0,
        oc3: 0,
        oc4: 0,
        oc5: 0
      },
      // 记录用户手动输入的 职业类别 人数
      categoryCounter: {
        oc3Count: 0,
        oc4Count: 0,
        oc5Count: 0
      }
    };
  },
  computed: {
    product() {
      return this.$store.getters.getProduct(this.code);
    },
    oc3Price() {
      const price = this.prices.oc1 + this.prices.oc2 + this.prices.oc3;
      return Math.round(price * 100) / 100;
    },
    oc3Count() {
      if (this.employees.length === 0) {
        return this.categoryCounter.oc3Count;
      }
      return this.employees.filter(item => item.category.level <= 3).length;
    },
    oc4Count() {
      if (this.employees.length === 0) {
        return this.categoryCounter.oc4Count;
      }
      return this.employees.filter(item => item.category.level === 4).length;
    },
    oc5Count() {
      if (this.employees.length === 0) {
        return this.categoryCounter.oc5Count;
      }
      return this.employees.filter(item => item.category.level === 5).length;
    },
    totalPrice() {
      const totalPrice = this.oc3Price + this.prices.oc4 + this.prices.oc5;
      return Math.round(totalPrice * 100) / 100;
    },
    disabledZyylx() {
      if (this.effectDuration < 4) {
        return true;
      }
      return false;
    }
  },
  watch: {
    totalPrice(totalPrice) {
      this.$emit("input", totalPrice);
    },
    // 保障期限变了，重新计算保费
    effectDuration() {
      this.getPrice(0);
    },
    // 保障方案变了，重新计算保费
    planId() {
      this.getPrice(0);
    },
    oc3Count() {
      this.getPrice(3);
    },
    oc4Count() {
      this.getPrice(4);
    },
    oc5Count() {
      this.getPrice(5);
    },
    // 人数变了，重新计算保费
    employees() {
      this.getPrice(0);
    }
  },
  created() {
    // 初始化 select items 数据
    this.selectesItems.forEach((element, index) => {
      element.oc3 = this.getSelectItems(index, 3);
      element.oc4 = this.getSelectItems(index, 4);
      element.oc5 = this.getSelectItems(index, 5);
    });
  },
  mounted() {
    this.getPrice(0);
  },
  methods: {
    calculate(expression) {
      return eval(expression);
    },
    /**
     * index: items 索引
     * occupationalCategory：职业类别
     */
    getSelectItems(index, occupationalCategory) {
      const item = this.items[index];
      const limit = item.limits.find(
        element =>
          element.minOccupationalCategory <= occupationalCategory &&
          element.maxOccupationalCategory >= occupationalCategory
      );
      // 没有匹配返回全部
      if (!limit) {
        return item.insuranceAmountList;
      }
      let maxInsuranceAmount = limit.maxInsuranceAmount;
      if (maxInsuranceAmount instanceof Array) {
        // 取数组最大值：排序后取最后一个
        let tempValue =
          item.insuranceAmountList[item.insuranceAmountList.length - 1].value;
        maxInsuranceAmount.forEach(element => {
          if (typeof element === "number") {
            tempValue = Math.min(element, tempValue);
          } else {
            const primary = this.items[0].selected["oc" + occupationalCategory];
            const expression = element.replace(/\$\{primary\}/g, primary); // primary = 主险保额
            const calculateValue = this.calculate(expression);
            tempValue = Math.min(calculateValue, tempValue);
          }
        });
        maxInsuranceAmount = tempValue;
      }
      const validList = item.insuranceAmountList.filter(
        element => element.value <= maxInsuranceAmount
      );
      return validList;
    },
    vselectOnChange(index, occupationalCategory) {
      if (index === 0) {
        for (let num = 1; num <= 2; num++) {
          this.selectesItems[num][
            "oc" + occupationalCategory
          ] = this.getSelectItems(num, occupationalCategory);
        }
      }
      setTimeout(() => {
        this.getPrice(occupationalCategory);
      }, 200);
    },
    getPrice(occupationalCategory) {
      // 没有保障期限无法计算保费
      if (!this.effectDuration) {
        return false;
      }
      // 需要计算的职业类别
      const categories =
        occupationalCategory === 0
          ? [1, 2, 3, 4, 5]
          : occupationalCategory === 3
          ? [1, 2, 3]
          : [occupationalCategory];

      let planList = [];

      categories.forEach(category => {
        const applicantCount = this.getCounterOfCategory(category);
        let planProductList = [];
        if (applicantCount > 0) {
          planProductList = this.items.map((item, index) => {
            const productId = this.product.children[index].id;
            // 住院医疗保险如果禁用了，保额传 0
            if (index === 3 && this.disabledZyylx) {
              return { productId, coverage: 0 };
            }
            const coverage =
              category === 5
                ? item.selected.oc5
                : category === 4
                ? item.selected.oc4
                : item.selected.oc3;
            return { productTermsId: productId, coverage };
          });
          planList.push({
            jobLevel: category,
            applicantCount: applicantCount,
            planProductTermsList: planProductList
          });
        }
      });

      this.$emit("update:planList", planList);
      // 没有 plan ，无需请求接口
      if (planList.length === 0) {
        return false;
      }

      const entity = {
        productId: parseInt(this.code),
        planId: this.planId,
        insurancePeriod: this.effectDuration,
        insurancePeriodUnit: 2,
        planList: planList
      };
      // 发起请求
      this.$axios
        .post("/app/api/gadd/trialPrice", entity)
        .then(res => {
          res.data.forEach(item => {
            this.prices["oc" + item.level] = item.basePrice;
          });
        })
        .catch(err => {
          console.log("err", err);
        });
    },
    getCounterOfCategory(category) {
      if (this.employees.length === 0) {
        let count = 0;
        if (category === 5) {
          count = this.categoryCounter.oc5Count;
        } else if (category === 4) {
          count = this.categoryCounter.oc4Count;
        } else if (category === 3) {
          count = this.categoryCounter.oc3Count;
        } else {
          count = 0;
        }
        if (isNaN(count)) {
          return 0;
        }
        return parseInt(count);
      }
      return this.employees.filter(item => item.category.level === category)
        .length;
    }
  }
};
</script>

<style lang="scss">
.c-insurance-plan {
  width: 745px;
  .thead-th {
    width: 195px;
    .thead-input {
      width: 3em;
      display: inline-block;
    }
  }
  // 框架样式覆盖
  .v-text-field.v-text-field--solo .v-input__control {
    flex: none;
    width: 120px;
    min-height: 30px;
  }
  .v-select {
    justify-content: center;
    font-size: inherit;
  }
}
</style>


